import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import { FiInfo } from 'react-icons/fi'
import type { CSSProperties } from 'react'

const wrapperStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  columnGap: '4px',
  padding: '8px 0'
}

const SutRequiredEeConnectionTypesDescription = () =>
  <div style={wrapperStyle}>
    <Color variant='theme-filter-icon'>
      <FiInfo
        aria-hidden
        size='16px'
      />
    </Color>
    <Paragraph>
      <strong>
        <Color variant='theme-description-text'>
          The selected SUT must be used with an execution environment.
        </Color>
      </strong>
    </Paragraph>
  </div>

export default SutRequiredEeConnectionTypesDescription
